import { FaFacebookF, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* About */}
        <div className="footer-section">
          <h3 className="footer-title">WeMindSolutions</h3>
          <p className="footer-text">
            Where Your Dreams Take Shape
          </p>
          
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3 className="footer-title">Services</h3>
          <ul className="footer-links">
            <li><Link to="/services">Web Development</Link></li>
            <li><Link to="/services">Mobile Apps</Link></li>
            <li><Link to="/services">Cloud Solutions</Link></li>
            <li><Link to="/services">UI/UX Design</Link></li>
            <li><Link to="/services">Digital Marketing</Link></li>
            <li><Link to="/services">IT Consulting</Link></li>
          </ul>
        </div>

        {/* Careers */}
        <div className="footer-section">
          <h3 className="footer-title">Careers</h3>
          <ul className="footer-links">
            <li><Link to="/careers">Open Positions</Link></li>
            <li><Link to="/careers">Internships</Link></li>
            <li><Link to="/careers">Why Work With Us</Link></li>
          </ul>
        </div>

        {/* Social */}
        <div className="footer-section">
          <h3 className="footer-title">Connect with us</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noreferrer">
              <FaTwitter />
            </a>
          </div>
           <div className="footer-section">
            <br></br>
          <p className="footer-text"><a href="https://www.gmail.com" target="_blank" rel="noreferrer">
            Contact@wemindsolutions.com</a>
          </p><p className="footer-text">
            WeMindSolutions Private Limited
          </p><p className="footer-text">
            Survey No 189, Hosur Bande, Mundur, Bangalore
          </p><p className="footer-text">
            Bangalore south, Karnataka, India, 560049.
          </p></div>
          
        </div>

      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        © 2026 WeMindSolutions Pvt. Ltd. All Rights Reserved.
      </div>
    </footer>
  );
}
